import {getMemberByVenueQuery} from './get-member-by-venue'

export const MemberQueries = {
  getMemberByVenueQuery,
}
